export default __webpack_public_path__ + "7e5077bf0b571a189ece7adb48ee2bf8.png";